
<template>
<a-form-model-item
    :label="label"
    :colon="false"
    :label-col="{span: 6}"
    :wrapper-col="{span: 18}"
    :prop="propStr"
    :rules="ruleStation?[]:name.RULES"
>
    <a-input
    v-if="!ruleStation || isLine"
    :value="contactName"
    :max-length="name.MAX_LENGTH"
    :placeholder="placeholder"
    :disabled="disabled"
    @change="onChange" />
    <div v-else>{{ruleStation.ext.contacts}}</div>
</a-form-model-item>
</template>

<script>
import FormValidator from '@/constants/formValidator'
import {tabListType} from "@/pages/orderManage/constant";
import minix from './minix'

const warehouseType = {
  in: 'STORE',
  out: 'DELIVER'
}
export default {
    mixins: [minix],
    model: {
        prop: 'contactName',
        event: 'change'
    },
    props: {
        contactName: {
            type: String,
            required: true
        },
        propName: {
            type: String,
            default: 'contactName'
        },
        disabled: {
            type: Boolean,
            default: false
        },
      ruleStation:{
          type:Object
      },
      isLine: {
        type: Boolean
      },
      scene: {
        type: String,
        default: ''
      },
      tab:{
        type:String,
        default: tabListType.WAREHOUSE
      }
    },
    data () {
        return {
          warehouseType,
            name: FormValidator.Name
        }
    },
    computed:{
      label(){
        if(this.scene === warehouseType.out&&this.tab !== tabListType.DELIVER_TRANSPORT) {
          return '提货人姓名'
        }
        return '联系人姓名'
      },
      placeholder(){
        if(this.scene === warehouseType.out&&this.tab !== tabListType.DELIVER_TRANSPORT) {
          return '请输入提货人姓名'
        }
        return '请输入联系人姓名'
      }
    },
    methods: {
        onChange({target}) {
            this.$emit('change', target.value)
        }
    },
}
</script>
